/**
 * Колесо мыши над полем type="number" в фокусе меняет его значение вместо прокрутки
 * страницы: в длинной форме число уезжает незаметно. Снимаем фокус до действия
 * браузера — значение остаётся прежним, страница прокручивается.
 */
export const blurNumberInputOnWheel = (event: Event): void => {
  const { target } = event;
  if (target instanceof HTMLInputElement && target.type === 'number' && target === document.activeElement) {
    target.blur();
  }
};

export const protectNumberInputsFromWheel = (): void => {
  document.addEventListener('wheel', blurNumberInputOnWheel, { capture: true, passive: true });
};
